<template>
  <div class="bet-type">
    <div
      :class="[
        'type',
        getBet.type == 'single' || getBet.type == 'multiple' ? 'active' : '',
        getBet.type == 'integral' ? 'disabled' : ''
      ]"
      @click="changeTypeCart('multiple')"
    >
      <span v-if="getBet.type == 'single' && getSettings.single">{{
        $t('single')
      }}</span>
      <span v-else>{{ $t('multiple') }}</span>
    </div>
    <div
      :class="['type', getBet.type == 'integral' ? 'active' : 'disabled']"
      v-if="getSettings.integral"
    >
      <span>{{ $t('integral') }}</span>
    </div>
    <div
      :class="[
        'type',
        getBet.type == 'system' ? 'active' : '',
        getBet.type == 'integral' ||
        getBet.type == 'single' ||
        getBet.odds.length == 1 ||
        getBet.odds.length > 10
          ? 'disabled'
          : ''
      ]"
      @click="changeTypeCart('system')"
      v-if="getSettings.system"
    >
      <span>{{ $t('system') }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BetTypeSelector',
  data: () => ({}),
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings'
    })
  },
  methods: {
    ...mapActions({
      refreshCart: 'cart/refreshCart',
      setBetType: 'cart/setBetType'
    }),

    async changeTypeCart(type) {
      const vue = this;
      if (vue.getBet.odds.length > 10 && type == 'system') {
        return;
      }
      if (
        vue.getBet.type != 'integral' &&
        vue.getBet.type != 'simple' &&
        vue.getBet.odds.length > 1
      ) {
        vue.checkedAll = false;
        await this.setBetType({ type: type });
        await this.refreshCart();
      }
    }
  }
};
</script>
